<template>
  <div>
    <h2>Texto</h2>
    <form action="" class="md-layout" @submit.prevent="submit">
      <md-field
        class="md-layout-item md-size-100"
        :class="getValidationClass('text')"
      >
        <label for="titulo"
          >Texto ($SENSOR, $VIRTUAL e $EXPR irá ser substituído pelo valor
          associado)</label
        >
        <md-input id="titulo" v-model="text" />
        <span v-if="$v.text" class="md-error">Texto obrigatório</span>
      </md-field>
      <sensor-autocomplete
        id="sensores"
        v-model="sensorId"
        name="sensores"
        class="md-layout-item md-size-100"
        :local-id="localId"
        :label="'Sensor ($SENSOR)'"
      />
      <sensor-virtual-autocomplete
        id="sensorVirtual"
        v-model="sensorVirtualId"
        name="sensorVirtual"
        class="md-layout-item md-size-100"
        :local-id="localId"
        :label="'Sensor Virtual ($VIRTUAL)'"
      />

      <div class="md-layout-item md-size-100">
        <span class="md-title">Expressão</span>

        <div class="md-layout pl-4">
          <md-field :class="getValidationClass('expressao')">
            <label for="expressao"
              >Expressão ($EXPR) valor de retorno é sempre um texto</label
            >
            <md-input id="expressao" v-model="expressao" />
          </md-field>

          <md-field>
            <label for="periodoTipo">Tipo de período</label>
            <md-select v-model="virtualSensorPeriodoTipo">
              <md-option :value="0"> Nenhum </md-option>
              <md-option :value="1"> Turno </md-option>
              <md-option :value="2"> Ultimas horas </md-option>
            </md-select>
          </md-field>

          <div class="md-layout-item">
            <SensorVirtualPeriodo
              :periodo-tipo="virtualSensorPeriodoTipo"
              :periodo-value="virtualSensorPeriodo"
              :local-id="localId"
              :only-form="true"
              @change="changeVirtualSensorPeriodo"
            />
          </div>
        </div>
      </div>

      <md-field
        class="md-layout-item md-size-100"
        :class="getValidationClass('fontSize')"
      >
        <label for="fontSize">Tamanho Font</label>
        <md-input id="fontSize" v-model="fontSize" />
        <span v-if="$v.fontSize" class="md-error"
          >Tamanho da Font obrigatório</span
        >
      </md-field>

      <md-field
        class="md-layout-item md-size-100"
        :class="getValidationClass('fontFamily')"
      >
        <label for="fontFamily">Font Family</label>
        <md-select
          id="fontFamily"
          v-model="fontFamily"
          name="fontFamily"
          md-dense
        >
          <md-option
            v-for="font in [
              'Roboto',
              'Arial',
              'Times New Roman',
              'Verdana',
              'Courier New',
            ]"
            :key="font"
            :value="font"
          >
            {{ font }}
          </md-option>
        </md-select>
        <span v-if="$v.fontFamily" class="md-error">Font obrigatória</span>
      </md-field>

      <md-field
        class="md-layout-item md-size-100"
        :class="getValidationClass('fontStyle')"
      >
        <label for="fontStyle">Font Style</label>
        <md-select id="fontStyle" v-model="fontStyle" name="fontStyle" md-dense>
          <md-option
            v-for="style in ['normal', 'italic', 'oblique']"
            :key="style"
            :value="style"
          >
            {{ style }}
          </md-option>
        </md-select>
        <span v-if="$v.fontStyle" class="md-error">Font style obrigatório</span>
      </md-field>

      <md-field
        class="md-layout-item md-size-100"
        :class="getValidationClass('fontWeight')"
      >
        <label for="fontWeight">FontWeight</label>
        <md-select
          id="fontWeight"
          v-model="fontWeight"
          name="fontWeight"
          md-dense
        >
          <md-option
            v-for="value in ['normal', 'bold', 'bolder', 'lighter']"
            :key="value"
            :value="value"
          >
            {{ value }}
          </md-option>
        </md-select>
        <span v-if="$v.fontWeight" class="md-error"
          >Font style obrigatório</span
        >
      </md-field>

      <md-field
        class="md-layout-item md-size-100"
        :class="getValidationClass('textAlign')"
      >
        <label for="textAlign">TextAlign</label>
        <md-select id="textAlign" v-model="textAlign" name="textAlign" md-dense>
          <md-option
            v-for="value in ['left', 'right', 'center', 'justify']"
            :key="value"
            :value="value"
          >
            {{ value }}
          </md-option>
        </md-select>
        <span v-if="$v.textAlign" class="md-error">TextAlign obrigatório</span>
      </md-field>

      <div class="md-layout md-gutter mt-2">
        <div class="md-layout-item md-size-50">
          <label class="md-subheading" for="color">Cor texto</label>
          <compact v-model="color" />
        </div>
        <div class="md-layout-item md-size-50">
          <label class="md-subheading" for="color">Cor fundo</label>
          <compact v-model="backgroundColor" />
        </div>
      </div>

      <div class="mt-3" style="text-align: right; width: 100%">
        <md-button class="md-raised md-accent" @click="() => $emit('close')">
          Cancelar
        </md-button>
        <md-button type="submit" class="md-raised md-primary">
          {{ isEdit ? 'Editar' : 'Cadastrar' }}
        </md-button>
      </div>
    </form>
  </div>
</template>

<script>
import Compact from 'vue-color/src/components/Compact.vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import { EventBus, Topics, Types } from '@/event-bus'
import { ComponenteTipo } from '@/utils/componente'
import http from '@/utils/http'

import SensorAutocomplete from '../../autocomplete/SensorAutocomplete.vue'
import SensorVirtualAutocomplete from '../../autocomplete/SensorVirtualAutocomplete.vue'
import SensorVirtualPeriodo from '../../sensor-virtual/SensorVirtualPeriodo.vue'

export default {
  name: 'ViewTextForm',
  components: {
    Compact,
    SensorAutocomplete,
    SensorVirtualAutocomplete,
    SensorVirtualPeriodo,
  },
  mixins: [validationMixin],
  props: {
    localId: {
      type: String,
      required: true,
    },
    viewId: {
      type: String,
      required: true,
    },
    componente: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      text: '',
      sensorId: null,
      sensorVirtualId: null,
      fontSize: '2em',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      textAlign: 'left',
      color: '#000000',
      backgroundColor: '#ffffff',
      equipamentos: [],
      expressao: '',
      virtualSensorPeriodoTipo: 0,
      virtualSensorPeriodo: {},
    }
  },
  validations: {
    text: { required },
    fontSize: { required },
    fontFamily: { required },
    fontStyle: { required },
    fontWeight: { required },
    textAlign: { required },
    color: { required },
    backgroundColor: { required },
  },
  computed: {
    isEdit() {
      return this.componente !== null
    },
  },
  async beforeMount() {
    if (this.componente !== null) {
      this.text = this.componente.value.text

      this.sensorId = this.componente.value.sensorId
      this.sensorVirtualId = this.componente.value.sensorVirtualId
      this.fontSize = this.componente.value.fontSize || this.fontSize
      this.fontFamily = this.componente.value.fontFamily || this.fontFamily
      this.fontStyle = this.componente.value.fontStyle || this.fontStyle
      this.fontWeight = this.componente.value.fontWeight || this.fontWeight
      this.textAlign = this.componente.value.textAlign || this.textAlign
      this.color = this.componente.value.color || this.color
      this.backgroundColor =
        this.componente.value.backgroundColor || this.backgroundColor
      this.expressao = this.componente.value.expressao || this.expressao
      this.virtualSensorPeriodoTipo =
        this.componente.value.virtualSensorPeriodoTipo ||
        this.virtualSensorPeriodoTipo
      this.virtualSensorPeriodo =
        this.componente.value.virtualSensorPeriodo || this.virtualSensorPeriodo
    }

    this.equipamentos = (
      await http.get(`local/${this.localId}/equipamentos`)
    ).equipamentos
  },
  methods: {
    changeVirtualSensorPeriodo(data) {
      this.virtualSensorPeriodo = data
    },
    async submit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      let response

      const value = {
        text: this.text,
        sensorId: this.sensorId,
        sensorVirtualId: this.sensorVirtualId,
        fontSize: this.fontSize,
        fontFamily: this.fontFamily,
        fontStyle: this.fontStyle,
        fontWeight: this.fontWeight,
        textAlign: this.textAlign,
        color: typeof this.color === 'string' ? this.color : this.color.hex,
        backgroundColor:
          typeof this.backgroundColor === 'string'
            ? this.backgroundColor
            : this.backgroundColor.hex,
        expressao: this.expressao,
        virtualSensorPeriodoTipo: this.virtualSensorPeriodoTipo,
        virtualSensorPeriodo: this.virtualSensorPeriodo,
      }

      if (this.virtualSensorPeriodoTipo === null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          message: 'Selecione um tipo de período',
          type: Types.WARNING,
        })
      }

      if (this.isEdit) {
        response = await http.put(`/view/componente`, {
          id: this.componente.id,
          z: this.componente.z,
          value: value,
        })
      } else {
        response = await http.post(`/view/componente`, {
          tipo: ComponenteTipo.TextView,
          viewId: this.viewId,
          value: value,
        })
      }

      if (response) {
        this.$emit('close')
        this.$emit('updated')
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
  },
}
</script>

<style scoped></style>
